import React, { Component } from "react";
import { connect } from "react-redux";
import {
  AddButton,
  AvailableOnlyAlert,
  CustomButton,
  DownloadButton,
} from "../helper/Buttons";
import { get, post } from "../util/api";
import Page from "../components/Page";
import {
  Box,
  Button,
  Checkbox,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputAdornment,
  Link,
  MenuItem,
  OutlinedInput,
  Paper,
  Popover,
  Select,
  styled,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import {
  IconAdjustmentsHorizontal,
  IconCircleCheckFilled,
  IconPlus,
  IconRestore,
  IconSearch,
  IconX,
} from "@tabler/icons-react";
import { IOSSwitch } from "../helper/inputs";

const PopoverContent = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.grey[900],
  color: theme.palette.common.white,
  border: `1px solid ${theme.palette.grey[800]}`,
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[10],
  padding: theme.spacing(2),
  width: "300px",
}));

const StatusTable = ({ formatted_data }) => {
  console.log("test ", formatted_data);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  return (
    <TableContainer sx={{ backgroundColor: "#131a25" }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell
              sx={{
                color: (theme) => theme.palette.primary.textColor,
                borderColor: "#151f2f",
              }}
            >
              Status
            </TableCell>
            {!isMobile && (
              <>
                <TableCell
                  sx={{
                    color: (theme) => theme.palette.primary.textColor,
                    borderColor: "#151f2f",
                  }}
                >
                  Name
                </TableCell>
                <TableCell
                  sx={{
                    color: (theme) => theme.palette.primary.textColor,
                    borderColor: "#151f2f",
                  }}
                >
                  Surname
                </TableCell>
                {/* <TableCell
                  sx={{
                    color: (theme) => theme.palette.primary.textColor,
                    borderColor: "#151f2f",
                  }}
                >
                  Monitor Id
                </TableCell> */}

                {/* <TableCell
                  sx={{
                    color: (theme) => theme.palette.primary.textColor,
                    borderColor: "#151f2f",
                  }}
                >
                  Control
                </TableCell> */}
                <TableCell
                  sx={{
                    color: (theme) => theme.palette.primary.textColor,
                    borderColor: "#151f2f",
                  }}
                >
                  Email
                </TableCell>
                <TableCell
                  sx={{
                    color: (theme) => theme.palette.primary.textColor,
                    borderColor: "#151f2f",
                  }}
                >
                  Phone
                </TableCell>
                <TableCell
                  sx={{
                    color: (theme) => theme.palette.primary.textColor,
                    borderColor: "#151f2f",
                  }}
                >
                  Role
                </TableCell>
              </>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {formatted_data.map((row, index) => (
            <TableRow
              key={index}
              component={Link}
              to={`/monitor/${row.id}`}
              sx={{
                textDecoration: "none",
                "&:hover": {
                  backgroundColor: "#151f2f",
                },
              }}
            >
              <TableCell
                sx={{
                  fontSize: 12,
                  color: (theme) =>
                    row.status == true
                      ? theme.palette.secondary.main
                      : theme.palette.error.main,
                  borderColor: "#151f2f",
                }}
              >
                <Box display="flex" alignItems="center">
                  {row.status == true ? (
                    <IconCircleCheckFilled
                      size={15}
                      style={{ marginRight: 5 }}
                    />
                  ) : (
                    <IconX size={15} style={{ marginRight: 5 }} />
                  )}
                  <span>{row.status ? "Active" : "Inactive"}</span>
                </Box>
                {isMobile && (
                  <>
                    {/* <Box sx={{ color: "#c9c9c9" }}>Id: {row.id}</Box> */}
                    <Box sx={{ color: "#c9c9c9" }}>Name: {row.name}</Box>
                    <Box sx={{ color: "#c9c9c9" }}>Surname: {row.surname}</Box>

                    {/* <Box sx={{ color: "#c9c9c9" }}>
                      Monitor Id: {row.monitor}
                    </Box> */}
                    {/* <Box sx={{ color: "#c9c9c9" }}>Control: {row.control}</Box> */}
                    <Box sx={{ color: "#c9c9c9" }}>Email: {row.email}</Box>
                    <Box sx={{ color: "#c9c9c9" }}>Phone: {row.phone}</Box>
                    <Box sx={{ color: "#c9c9c9" }}>Role: {row.role}</Box>
                  </>
                )}
              </TableCell>
              {!isMobile && (
                <>
                  {/* <TableCell
                    sx={{
                      fontSize: 12,
                      color: (theme) => theme.palette.primary.secondTextColor,
                      borderColor: "#151f2f",
                    }}
                  >
                    {row.type}
                  </TableCell> */}
                  {/* <TableCell
                    sx={{
                      fontSize: 12,
                      color: (theme) => theme.palette.primary.secondTextColor,
                      borderColor: "#151f2f",
                    }}
                  >
                    {row.monitor}
                  </TableCell> */}
                  <TableCell
                    sx={{
                      fontSize: 12,
                      color: (theme) => theme.palette.primary.secondTextColor,
                      borderColor: "#151f2f",
                    }}
                  >
                    {row.name}
                  </TableCell>
                  <TableCell
                    sx={{
                      fontSize: 12,
                      color: (theme) => theme.palette.primary.secondTextColor,
                      borderColor: "#151f2f",
                    }}
                  >
                    {row.surname}
                  </TableCell>
                  <TableCell
                    sx={{
                      fontSize: 12,
                      color: (theme) => theme.palette.primary.secondTextColor,
                      borderColor: "#151f2f",
                    }}
                  >
                    {row.email}
                  </TableCell>
                  <TableCell
                    sx={{
                      fontSize: 12,
                      color: (theme) => theme.palette.primary.secondTextColor,
                      borderColor: "#151f2f",
                    }}
                  >
                    {row.phone}
                  </TableCell>
                  <TableCell
                    sx={{
                      fontSize: 12,
                      color: (theme) => theme.palette.primary.secondTextColor,
                      borderColor: "#151f2f",
                    }}
                  >
                    {row.role}
                  </TableCell>
                </>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

class Team extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      team_list: [],
      openAddModal: false,
      newMember: {
        name: "",
        surname: "",
        email: "",
        phone: "",
        role: "",
        status: true,
      },
    };
  }

  componentDidMount() {
    document.title = "Team | Statusnap";
    this.getTeam();
  }

  getTeam = async () => {
    await get(`/statusnap/team`, {})
      .then((data) => {
        if (data.success) {
          this.setState({ team_list: data?.data });
        }
      })
      .catch((err) => {
        console.log(err);
      });
    this.setState({ loading: false });
  };

  addTeamMember = async () => {
    const { newMember } = this.state;
    try {
      const res = await post("/statusnap/add-team-member", newMember);
      if (res?.data.success) {
        this.getTeam();
        this.setState({ openAddModal: false });
      } else {
        console.error("Error creating team member", res.message);
      }
    } catch (e) {
      console.error("API error:", e);
    }
  };

  handleOpenModal = () => {
    this.setState({ openAddModal: true });
  };

  handleCloseModal = () => {
    this.setState({ openAddModal: false });
  };

  render() {
    let { loading, team_list } = this.state;
    console.log("this ", this.props);
    if (loading) return <Page.Loader key="loader" />;
    if (!team_list || (team_list && team_list.length <= 0))
      return (
        <Container style={{ padding: 0, textAlign: "center" }}>
          <Typography variant="h6" sx={{ color: "white", marginBottom: 1 }}>
            You don’t have any team members yet. Create your first one to begin
            collaborating!
          </Typography>
          <AddButton onClick={this.handleOpenModal} text={"Add Team Member"} />
          <Dialog
            open={this.state.openAddModal}
            onClose={this.handleCloseModal}
          >
            <DialogTitle sx={{ background: "#151f2f", color: "white" }}>
              Add Team Member
            </DialogTitle>
            <DialogContent sx={{ background: "#131a25" }}>
              <TextField
                margin="dense"
                label="Name"
                fullWidth
                value={this.state.newMember.name}
                onChange={(e) =>
                  this.setState({
                    newMember: {
                      ...this.state.newMember,
                      name: e.target.value,
                    },
                  })
                }
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  style: {
                    color: "white",
                    caretColor: "white",
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#c9c9c9",
                    },
                    "&:hover fieldset": {
                      borderColor: "#15a32a",
                    },
                  },
                  "& .MuiInputLabel-root": {
                    color: "#c9c9c9",
                  },
                  "& .MuiFormHelperText-root": {
                    color: "#c9c9c9",
                  },
                }}
              />
              <TextField
                margin="dense"
                label="Surname"
                fullWidth
                value={this.state.newMember.surname}
                onChange={(e) =>
                  this.setState({
                    newMember: {
                      ...this.state.newMember,
                      surname: e.target.value,
                    },
                  })
                }
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  style: {
                    color: "white",
                    caretColor: "white",
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#c9c9c9",
                    },
                    "&:hover fieldset": {
                      borderColor: "#15a32a",
                    },
                  },
                  "& .MuiInputLabel-root": {
                    color: "#c9c9c9",
                  },
                  "& .MuiFormHelperText-root": {
                    color: "#c9c9c9",
                  },
                }}
              />
              <TextField
                margin="dense"
                label="Email"
                fullWidth
                value={this.state.newMember.email}
                onChange={(e) =>
                  this.setState({
                    newMember: {
                      ...this.state.newMember,
                      email: e.target.value,
                    },
                  })
                }
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  style: {
                    color: "white",
                    caretColor: "white",
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#c9c9c9",
                    },
                    "&:hover fieldset": {
                      borderColor: "#15a32a",
                    },
                  },
                  "& .MuiInputLabel-root": {
                    color: "#c9c9c9",
                  },
                  "& .MuiFormHelperText-root": {
                    color: "#c9c9c9",
                  },
                }}
              />
              <TextField
                margin="dense"
                label="Phone"
                fullWidth
                value={this.state.newMember.phone}
                onChange={(e) =>
                  this.setState({
                    newMember: {
                      ...this.state.newMember,
                      phone: e.target.value,
                    },
                  })
                }
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  style: {
                    color: "white",
                    caretColor: "white",
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#c9c9c9",
                    },
                    "&:hover fieldset": {
                      borderColor: "#15a32a",
                    },
                  },
                  "& .MuiInputLabel-root": {
                    color: "#c9c9c9",
                  },
                  "& .MuiFormHelperText-root": {
                    color: "#c9c9c9",
                  },
                }}
              />
              <TextField
                margin="dense"
                label="Role"
                fullWidth
                select
                value={this.state.newMember.role}
                onChange={(e) =>
                  this.setState({
                    newMember: {
                      ...this.state.newMember,
                      role: e.target.value,
                    },
                  })
                }
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  style: {
                    color: "white",
                    caretColor: "white",
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#c9c9c9",
                    },
                    "&:hover fieldset": {
                      borderColor: "#15a32a",
                    },
                  },
                  "& .MuiInputLabel-root": {
                    color: "#c9c9c9",
                  },
                  "& .MuiFormHelperText-root": {
                    color: "#c9c9c9",
                  },
                }}
              >
                <MenuItem value="owner" sx={{ color: "white" }}>
                  Owner
                </MenuItem>
                <MenuItem sx={{ color: "white" }} value="admin">
                  Admin
                </MenuItem>
                <MenuItem sx={{ color: "white" }} value="editor">
                  Editor
                </MenuItem>
                <MenuItem sx={{ color: "white" }} value="viewer">
                  Viewer
                </MenuItem>
                <MenuItem sx={{ color: "white" }} value="alertOnly">
                  Alert Only
                </MenuItem>
              </TextField>
              <FormControlLabel
                sx={{
                  color: "white",
                  marginLeft: "3px",
                  marginTop: "15px",
                  gap: "8px",
                }}
                label="Status"
                control={
                  <IOSSwitch
                    checked={this.state.newMember.status}
                    onChange={(e) =>
                      this.setState({
                        newMember: {
                          ...this.state.newMember,
                          status: e.target.checked,
                        },
                      })
                    }
                  />
                }
              />
            </DialogContent>
            <DialogActions sx={{ background: "#151f2f", color: "white" }}>
              <Button onClick={this.handleCloseModal} sx={{ color: "white" }}>
                Cancel
              </Button>
              <AddButton
                onClick={this.addTeamMember}
                text={"Save"}
                sx={{ color: "white" }}
              />
            </DialogActions>
          </Dialog>
        </Container>
      );
    return (
      <>
        <Box
          sx={{
            display: "flex",
            "@media screen and (max-width: 600px)": {
              display: "block",
              width: "100%",
            },
          }}
          flex={{ xs: "1 1 auto", md: "0 0 100%" }}
        >
          <FormControl
            sx={{
              mt: 1,
              marginTop: 0,
              justifyContent: "center",
              "@media screen and (max-width: 600px)": {
                width: "100%",
              },
            }}
          >
            <OutlinedInput
              id="outlined-adornment-amount"
              placeholder="Search by Name, Email, Phone, Role"
              onChange={(e) => {
                let { value } = e.target;
                this.changeSearch(value);
              }}
              startAdornment={
                <InputAdornment position="start">
                  <IconSearch
                    size={15}
                    sx={{
                      color: (theme) => theme.palette.primary.secondTextColor,
                    }}
                  />
                </InputAdornment>
              }
              className="custom-nonetextfield"
              sx={{
                caretColor: "#e0e0e0",
                color: "#e0e0e0",
                height: 35,
                width: 250,
                fontSize: 13,
                paddingRight: 1,
                "& .MuiOutlinedInput-root": {
                  color: (theme) => theme.palette.primary.secondTextColor,
                },
                "& .MuiInputAdornment-root": {
                  color: (theme) => theme.palette.primary.secondTextColor,
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#dfdfdfa1",
                  borderWidth: "thin",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#dfdfdfa1",
                  borderWidth: "thin",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#dfdfdfa1",
                  borderWidth: "thin",
                },
              }}
            />
          </FormControl>

          <div
            style={{
              marginBottom: "6px",
              marginLeft: "auto",
            }}
          >
            <div
              style={{
                marginTop: "6px",
                marginBottom: "6px",
                display: "inline-block",
              }}
            ></div>
            {/* <AddButton
              text={
                "New Monitor" +
                ` (${soft_formatted_data.length}/${subscription.limit})`
              }
              component={Link}
              to={`/monitors/create`}
              sx={{
                "@media screen and (max-width: 600px)": {
                  marginTop: "10px",
                  width: "100%",
                },
                md: { width: "100%" },
              }}
            /> */}
            {/* <CustomButton
              active={true}
              limited={
                soft_formatted_data?.length == subscription?.cluster_limit &&
                !!subscription?.custom
                  ? true
                  : false
              }
              icon={<IconPlus />}
              text={
                "New Cluster" +
                ` (${soft_formatted_data.length}/${subscription.cluster_limit})`
              }
              component={Link}
              to={`/monitors/create`}
              sx={{
                "@media screen and (max-width: 600px)": {
                  marginTop: "10px",
                  width: "100%",
                },
                md: { width: "100%" },
              }}
            /> */}
          </div>
        </Box>
        {/* <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={() => {
            this.setState({ anchorEl: !anchorEl });
          }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          <PopoverContent
            sx={{
              borderRadius: "0",
              background: "#151f2f",
              border: "none",
            }}
          >
            <div
              style={{
                marginBottom: "6px",
                marginLeft: "auto",
              }}
            >
              <FormGroup
                sx={{
                  "@media screen and (max-width: 600px)": {
                    width: "100%",
                  },
                  color: "#727881",
                }}
              >
                {_.map(FilterClusters, (e, i) => {
                  return (
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="success"
                          checked={
                            this.state.checked_list &&
                            this.state.checked_list.length > 0 &&
                            this.state.checked_list.includes(e.value)
                          }
                          sx={{
                            "&.MuiCheckbox-root": {
                              color: "#c9c9c9",
                            },
                            "&.Mui-checked": {
                              color: "#007A33",
                            },
                          }}
                          onChange={(c) => {
                            this.changeFilter2(e.value, c);
                          }}
                        />
                      }
                      sx={{ color: "#c9c9c9" }}
                      label={e.key}
                    />
                  );
                })}
                <CustomButton
                  text="Reset"
                  aria-describedby={id}
                  sx={{ marginRight: "5px" }}
                  onClick={() => {
                    removeFromLocalStorage("filter_cluster");
                    this.setState({
                      checked_list: [],
                      formatted_data: soft_formatted_data,
                    });
                  }}
                  icon={<IconRestore />}
                />
              </FormGroup>
            </div>
          </PopoverContent>
        </Popover> */}
        <StatusTable formatted_data={team_list} />
      </>
    );
  }
}

export default connect((state) => ({
  user: state.access.user.loggedUserObj,
  product: state.product.undefined,
}))(Team);
